import {
  SecurityTypeEnum,
  ScenarioTypeEnum,
  ComplexityTierEnum,
} from "../../types/interfaces/create-transaction.interfaces";
import { MedallionType, OwnershipType, OwnershipTypes } from "../../types/main";
import { Action } from "../actions";
import { ScenarioAnswer } from "../../config/scenario-tree.types";

/**
 * Scenario data from the questionnaire, stored in Redux for persistence
 * across component remounts and accessibility in checkout/payment steps.
 */
export interface ScenarioData {
  scenarioType: ScenarioTypeEnum;
  complexityTier: ComplexityTierEnum;
  isIntermediary: boolean;
  scenarioAnswers: { answers: ScenarioAnswer[] };
}

export interface CheckoutState {
  ownershipType: OwnershipType;
  medallionType: MedallionType;
  readyForSecondStepCheckout: boolean;
  readyForThirdStepCheckout: boolean;
  medallions: any;
  // Scenario identification data from questionnaire
  scenarioData: ScenarioData | null;
}

const initialState: CheckoutState = {
  ownershipType: OwnershipTypes.PRIVATE,
  medallionType: SecurityTypeEnum.PUBLIC,
  readyForSecondStepCheckout: false,
  readyForThirdStepCheckout: false,
  medallions: [],
  scenarioData: null,
};

export const CheckoutReducer = (
  state: CheckoutState = initialState,
  action: Action
) => {
  switch (action.type) {
    case "SET_OWNER_SHIP_TYPE": {
      return { ...state, ownershipType: action.payload };
    }
    case "SET_MEDALLION_TYPE": {
      return { ...state, medallionType: action.payload };
    }
    case "READY_FOR_SECOND_STEP_CHECKOT": {
      return { ...state, readyForSecondStepCheckout: action.payload };
    }
    case "READY_FOR_THIRD_STEP_CHECKOT": {
      return { ...state, readyForThirdStepCheckout: action.payload };
    }
    case "SET_MEDALLIONS": {
      return { ...state, medallions: action.payload };
    }
    case "SET_SCENARIO_DATA": {
      return { ...state, scenarioData: action.payload };
    }
    case "CLEAR_SCENARIO_DATA": {
      return { ...state, scenarioData: null };
    }
    default:
      return state;
  }
};
